import React from "react";
import { theme } from "antd";

interface EmptyNotificationsProps {
  title?: string;
  subtitle?: string;
  width?: number | string;
  height?: number | string;
}

const EmptyNotifications: React.FC<EmptyNotificationsProps> = ({
  title = "No notifications yet",
  subtitle = "Updates about this application will show up here",
  width = "100%",
  height = "auto",
}) => {
  const { token } = theme.useToken();

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <svg
        style={{ width, height, display: "block", maxWidth: 680 }}
        viewBox="0 0 680 320"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        aria-label={title}
      >
        <title>{title}</title>
        <desc>An illustration of a quiet notification bell with an empty badge and drifting sleep marks</desc>

        <ellipse cx="340" cy="272" rx="96" ry="8" fill="#e8e4f8" />

        <circle cx="340" cy="150" r="110" fill="#e8e4f8" />
        <circle cx="340" cy="150" r="110" fill="none" stroke="#c4baf0" strokeWidth="1.5" />

        <circle cx="340" cy="66" r="9" fill="#d4cef5" stroke="#b8b0e8" strokeWidth="1.2" />

        <circle cx="340" cy="220" r="13" fill="#7c6fcd" />

        <path
          d="M340 74 C302 74 284 102 284 140 L284 178 L268 200 L412 200 L396 178 L396 140 C396 102 378 74 340 74 Z"
          fill="#ffffff"
          stroke="#d0cbe8"
          strokeWidth="1.2"
          strokeLinejoin="round"
        />
        <path
          d="M306 150 L306 138 C306 116 316 100 332 94"
          fill="none"
          stroke="#c4baf0"
          strokeWidth="2.5"
          strokeLinecap="round"
          opacity="0.5"
        />
        <line
          x1="300"
          y1="178"
          x2="380"
          y2="178"
          stroke="#c4baf0"
          strokeWidth="2.5"
          strokeLinecap="round"
          opacity="0.3"
        />

        <rect x="262" y="196" width="156" height="12" rx="6" fill="#d4cef5" />
        <rect x="262" y="196" width="156" height="12" rx="6" fill="none" stroke="#b8b0e8" strokeWidth="1.2" />

        <circle cx="394" cy="92" r="16" fill="#ffffff" stroke="#a99ee0" strokeWidth="1.5" strokeDasharray="4 4" />

        <g fill="none" stroke="#a99ee0" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="428,62 442,62 428,76 442,76" strokeWidth="2.5" opacity="0.7" />
          <polyline points="452,40 462,40 452,50 462,50" strokeWidth="2.2" opacity="0.5" />
          <polyline points="470,24 477,24 470,31 477,31" strokeWidth="1.8" opacity="0.35" />
        </g>

        <circle cx="206" cy="112" r="4" fill="#c4baf0" opacity="0.5" />
        <circle cx="192" cy="128" r="2.5" fill="#c4baf0" opacity="0.35" />
        <circle cx="210" cy="142" r="1.8" fill="#c4baf0" opacity="0.25" />

        <circle cx="476" cy="186" r="4" fill="#c4baf0" opacity="0.5" />
        <circle cx="490" cy="171" r="2.5" fill="#c4baf0" opacity="0.35" />
        <circle cx="484" cy="202" r="1.8" fill="#c4baf0" opacity="0.25" />

        <path
          d="M232 48 L233.5 52 L238 53.5 L233.5 55 L232 59 L230.5 55 L226 53.5 L230.5 52 Z"
          fill="#a99ee0"
          opacity="0.45"
        />
        <path
          d="M470 230 L472 236 L478 238 L472 240 L470 246 L468 240 L462 238 L468 236 Z"
          fill="#a99ee0"
          opacity="0.4"
        />
      </svg>

      {(title || subtitle) && (
        <div style={{ textAlign: "center", marginTop: 8 }}>
          {title && (
            <p style={{ margin: 0, fontSize: 15, color: token.colorTextSecondary, fontWeight: 400 }}>{title}</p>
          )}
          {subtitle && (
            <p style={{ margin: "4px 0 0", fontSize: 13, color: token.colorTextTertiary, fontWeight: 400 }}>
              {subtitle}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default EmptyNotifications;
